/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        type: "constructor",
        inputs: [
            {
                name: "_addressesProvider",
                type: "address",
                internalType: "contract IPoolAddressesProvider",
            },
            {
                name: "_adapter",
                type: "address",
                internalType: "contract BaseALMAdapter",
            },
        ],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "adapter",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "contract BaseALMAdapter",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "addressesProvider",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "contract IPoolAddressesProvider",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "deleverage",
        inputs: [
            {
                name: "flashloanProvider",
                type: "address",
                internalType: "contract IERC3156FlashLender",
            },
            {
                name: "params",
                type: "tuple",
                internalType: "struct BaseERC20LeveragedPosition.DeleverageParams",
                components: [
                    {
                        name: "assetConverter",
                        type: "address",
                        internalType: "contract IAssetConverter",
                    },
                    {
                        name: "maxSwapSlippage",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "receiver",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "withdrawLiquidity",
                        type: "bool",
                        internalType: "bool",
                    },
                ],
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "executeOperation",
        inputs: [
            {
                name: "",
                type: "address[]",
                internalType: "address[]",
            },
            {
                name: "",
                type: "uint256[]",
                internalType: "uint256[]",
            },
            {
                name: "",
                type: "uint256[]",
                internalType: "uint256[]",
            },
            {
                name: "initiator",
                type: "address",
                internalType: "address",
            },
            {
                name: "_params",
                type: "bytes",
                internalType: "bytes",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "getDebt",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "initialize",
        inputs: [
            {
                name: "params",
                type: "tuple",
                internalType: "struct BaseERC20LeveragedPosition.PositionInitParams",
                components: [
                    {
                        name: "lpToken",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "lpAmount",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "tokenToBorrow",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "amountToBorrow",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "assetConverter",
                        type: "address",
                        internalType: "contract IAssetConverter",
                    },
                    {
                        name: "maxSwapSlippage",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "owner",
                        type: "address",
                        internalType: "address",
                    },
                ],
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "lpToken",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "onFlashLoan",
        inputs: [
            {
                name: "initiator",
                type: "address",
                internalType: "address",
            },
            {
                name: "token",
                type: "address",
                internalType: "address",
            },
            {
                name: "amount",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "flashFee",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "data",
                type: "bytes",
                internalType: "bytes",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "owner",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "pool",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "contract IPool",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "renounceOwnership",
        inputs: [],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "token0",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "token1",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "tokenToBorrow",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "transferOwnership",
        inputs: [
            {
                name: "newOwner",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "event",
        name: "Deleverage",
        inputs: [],
        anonymous: false,
    },
    {
        type: "event",
        name: "Initialized",
        inputs: [
            {
                name: "version",
                type: "uint64",
                indexed: false,
                internalType: "uint64",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "OwnershipTransferred",
        inputs: [
            {
                name: "previousOwner",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "newOwner",
                type: "address",
                indexed: true,
                internalType: "address",
            },
        ],
        anonymous: false,
    },
    {
        type: "error",
        name: "AddressEmptyCode",
        inputs: [
            {
                name: "target",
                type: "address",
                internalType: "address",
            },
        ],
    },
    {
        type: "error",
        name: "AddressInsufficientBalance",
        inputs: [
            {
                name: "account",
                type: "address",
                internalType: "address",
            },
        ],
    },
    {
        type: "error",
        name: "FailedInnerCall",
        inputs: [],
    },
    {
        type: "error",
        name: "InvalidCaller",
        inputs: [],
    },
    {
        type: "error",
        name: "InvalidInitialization",
        inputs: [],
    },
    {
        type: "error",
        name: "InvalidInitiator",
        inputs: [],
    },
    {
        type: "error",
        name: "NotInitializing",
        inputs: [],
    },
    {
        type: "error",
        name: "OwnableInvalidOwner",
        inputs: [
            {
                name: "owner",
                type: "address",
                internalType: "address",
            },
        ],
    },
    {
        type: "error",
        name: "OwnableUnauthorizedAccount",
        inputs: [
            {
                name: "account",
                type: "address",
                internalType: "address",
            },
        ],
    },
    {
        type: "error",
        name: "SafeERC20FailedOperation",
        inputs: [
            {
                name: "token",
                type: "address",
                internalType: "address",
            },
        ],
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class ALMLeveragedPosition__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_addressesProvider, _adapter, overrides) {
        return super.deploy(_addressesProvider, _adapter, overrides || {});
    }
    getDeployTransaction(_addressesProvider, _adapter, overrides) {
        return super.getDeployTransaction(_addressesProvider, _adapter, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
ALMLeveragedPosition__factory.bytecode = _bytecode;
ALMLeveragedPosition__factory.abi = _abi;
//# sourceMappingURL=ALMLeveragedPosition__factory.js.map